import { createStyles, WithStyles, withStyles } from "@material-ui/core";
import {
    CopyIcon,
    EditIcon,
    NewMessageIcon,
    PageActionButton,
    RelodeTheme,
    ShareAltIcon,
} from "@relode/core";
import * as React from "react";

const styles = (theme: RelodeTheme) =>
    createStyles({
        pageActionButtonsContainer: {
            display: "flex",
        },
    });

interface Props extends WithStyles<typeof styles> {
    shareAction?: (boolean) => void;
    messageAction?: (boolean) => void;
    jobCopyAction?: () => void;
    jobEditAction?: () => void;
}

export const JobActionOptionsDesktop = withStyles(styles, {
    name: "JobActionOptionsDesktop",
})((props: Props) => {
    const {
        classes,
        shareAction,
        messageAction,
        jobCopyAction,
        jobEditAction,
    } = props;

    const hasActions = !!messageAction || !!shareAction;

    if (!hasActions) return null;

    return (
        <div className={classes.pageActionButtonsContainer}>
            {!!messageAction ? (
                <PageActionButton
                    data-cy="actionBarMessageComposerButton"
                    onClick={() => messageAction(true)}
                    id="sendMessage"
                    color="primary"
                    title="send a message"
                >
                    <NewMessageIcon />
                </PageActionButton>
            ) : null}
            {!!shareAction ? (
                <PageActionButton
                    data-cy="actionBarShareButton"
                    onClick={() => shareAction(true)}
                    id="share"
                    color="primary"
                    title="share job with prospects"
                >
                    <ShareAltIcon />
                </PageActionButton>
            ) : null}
            {!!jobCopyAction ? (
                <PageActionButton
                    data-cy="actionCopyJobButton"
                    onClick={() => jobCopyAction()}
                    id="copyJob"
                    color="primary"
                    title="copy job"
                >
                    <CopyIcon />
                </PageActionButton>
            ) : null}
            {!!jobEditAction ? (
                <PageActionButton
                    data-cy="actionEditJobButton"
                    onClick={() => jobEditAction()}
                    id="editJob"
                    color="primary"
                    title="edit job"
                >
                    <EditIcon />
                </PageActionButton>
            ) : null}
        </div>
    );
});
